// O clique no trigger não chama /cart/add.js: monta um item pendente e
// deixa o overlay resolver a variante certa depois que o tamanho é escolhido.
/**
 * data-gifts vem em pseudo-JSON de aspas simples.
 * @param {string | undefined} raw
 * @returns {any[] | null}
 */
function parseGiftsDataset(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw.replace(/'/g, '"'));
  } catch {
    return null;
  }
}

class ZRZSQuickAddTrigger extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.zrzs-quick-add-trigger__button');
    if (!this.button) return;
    this.button.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleClick);
    }
  }

  /** @param {MouseEvent} event */
  handleClick = event => {
    // O card inteiro é um link — evita navegar pra PDP no clique do botão.
    event.preventDefault();
    event.stopPropagation();

    if (!this.button || this.button.disabled) return;

    const {
      variantId,
      variantTitle,
      kitVariantId,
      hasLensBasket,
      isSolar,
      productUrl,
      productTitle,
      image,
      price,
      sizes,
      kitCaseBanner,
      kitCaseDescription,
      gifts,
      hasMeasurements,
    } = this.button.dataset;
    if (!variantId) return;

    let parsedSizes = null;
    if (sizes) {
      try {
        parsedSizes = JSON.parse(sizes);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[QuickAddTrigger] data-sizes inválido:', error);
      }
    }

    // Duplo/triplo clique disparava um /cart/add.js por clique pra solar
    // sem escolha de tamanho (o commit agora roda direto em
    // handlePendingOpen, sem passar pelo botão "ver carrinho" do overlay,
    // que era onde esse guard vivia antes) — reabilita só quando aquele
    // clique específico terminar de ser processado (ver onSettled abaixo).
    // Só desabilita aqui, depois de garantir que o evento vai mesmo
    // disparar — nunca antes de um `return` que deixaria o botão preso.
    this.button.disabled = true;

    document.dispatchEvent(
      new CustomEvent('zrzs:quick-add:open', {
        detail: {
          pending: true,
          item: {
            image: image || '',
            product_title: productTitle || '',
            variant_title: variantTitle || '',
            price: price ? Number(price) : 0,
            url: productUrl || '',
          },
          frameVariantId: variantId,
          frameVariantTitle: variantTitle || '',
          kitVariantId: kitVariantId || null,
          hasLensBasket: hasLensBasket === 'true',
          isSolar: isSolar === 'true',
          sizes: parsedSizes,
          hasMeasurements: hasMeasurements === 'true',
          kitCaseBanner: kitCaseBanner || null,
          kitCaseDescription: kitCaseDescription || null,
          giftsData: parseGiftsDataset(gifts),
          onSettled: () => {
            if (this.button) this.button.disabled = false;
          },
        },
      })
    );
  };
}

if (!customElements.get('zrzs-quick-add-trigger')) {
  customElements.define('zrzs-quick-add-trigger', ZRZSQuickAddTrigger);
}
